const querySchemaLowerCase = {
    elqformname: "elqFormName",
    elqsiteid: "elqSiteId",
    elqcampaignid: "elqCampaignId",
    first_name: "first_name",
    last_name: "last_name",
    company: "company",
    email: "email",
    title: "title",
    role: "role",
    phone: "phone",
    country: "country",
    state: "state",
    mobile: "mobile",
    querystring: "querystring",
    channel: "channel",
    importsourcemostrecent1: "importSourceMostRecent1",
    leadsourcemostrecent1: "leadSourceMostRecent1",
    leadvehicle: "leadVehicle",
    mqlflag: "MQLFlag",
    assettype: "assetType",
    emailassetcode: "EmailAssetCode",
    redirectcode: "RedirectCode",
    industry: "Industry",
    campaignid: "CampaignID",
    landingpageurl: "LandingPageURL",
    sfdclastcampaignstatus: "sFDCLastCampaignStatus",
    url: "url",
    emailname: "emailName",
    guid1: "gUID1",
    numberattending: "numberattending",
    namescoming: "namescoming",
    anythingtoadd: "anythingtoadd",
    buyingjourney1: "buyingJourney1",
    institutionsize1: "institutionSize1",
    lastaccessedassetid1: "lastAccessedAssetID1",
    explicitoptin: "ExplicitOptIn",
    gclid: "gclid",
    howdidyouhearaboutus1: "howDidYouHearAboutUs1"
};

export default function getUrlParams() {
    const { search } = window.location;
    const hashes = search.slice(search.indexOf("?") + 1).split("&");
    // if values, construct an object out of them
    if (hashes[0]) {
        return hashes.reduce((params, hash) => {
            const split = hash.indexOf("=");
            const key = hash.slice(0, split).toLowerCase();
            const val = hash.slice(split + 1);
            // ensure param is in schema
            if (key in querySchemaLowerCase) {
                return Object.assign(params, {
                    [querySchemaLowerCase[key]]: decodeURIComponent(val)
                });
            }
            return params;
        }, {});
    }
    return {}; // default to empty object
}
